import { getVersionedComponent } from '@/HOCs';

import HeaderV1 from './HeaderV1';
import HeaderV2 from './HeaderV2';

export default getVersionedComponent({
  V1: HeaderV1,
  V2: HeaderV2,
});
